import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { setJoinRequestFromSocket } from "../features/duelsJoinRequest/joinRequestSlice";

const useJoinRequestSync = ({ userId, socket, isReady, enabled = true }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!enabled || !socket || !isReady || !userId) return;

    const syncRequestsFromSocket = (data) => {
      const requests = Array.isArray(data)
        ? data
        : Array.isArray(data?.requests)
          ? data.requests
          : [];
      dispatch(setJoinRequestFromSocket(requests));
    };

    socket.on("new-join-request", syncRequestsFromSocket);
    return () => {
      socket.off("new-join-request", syncRequestsFromSocket);
    };
  }, [dispatch, enabled, isReady, socket, userId]);
};

export default useJoinRequestSync;
